import React from 'react'
import { Link } from "react-router-dom";
import '../../css/Team.css';
import sateam from '../../images/sateam.png';
import starmark from '../../images/starmark.png';
import rohitgupta from '../../images/team/rohitgupta.jpg';
import ashishharwani from '../../images/team/ashishharwani.jpg';
import mukeshprajapat from '../../images/team/mukeshprajapat.jpg';
import krishankumarsaini from '../../images/team/krishankumarsaini.jpg';
import vimalkumar from '../../images/team/vimalkumar.jpg';
import manojdhawan from '../../images/team/manojdhawan.jpg';
import anilsharma from '../../images/team/anilsharma.jpg';
import jatinkumawat from '../../images/team/jatinkumawat.jpg';
import omchoudhary from '../../images/team/omchoudhary.jpg';
import shivkumargurjar from '../../images/team/shivkumargurjar.jpg';
import sunayanasingh from '../../images/team/sunayanasingh.jpg';
import shwetasharma from '../../images/team/shwetasharma.jpg';
import sumitsaini from '../../images/team/sumitsaini.jpg';
import girdharikoolwal from '../../images/team/girdharikoolwal.jpg';
import pankajmishra from '../../images/team/pankajmishra.jpg';
import rahulsaini from '../../images/team/rahulsaini.jpg';
import himanshubhardwaj from '../../images/team/himanshubhardwaj.jpg';
import rajivkumarjonwal from '../../images/team/rajivkumarjonwal.jpg';
import komalsharma from '../../images/team/komalsharma.jpg';
import rekhayadav from '../../images/team/rekhayadav.jpg';
import profile from '../../images/profile.gif';


const Blogs = () => {
  return (
    <>
      <section className='teambanner-section'>
        <div className='abttagline'>
          <h1>Our Team</h1>
          <h5>Minds Behind the Mission</h5>
        </div>
        <img src={sateam} className='sateam desk' />
      </section>

      <section className='team-section'>
        <div className='container-fluid'>
          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Meet the Professionals Leadership of<br /><span>SiddhiAnanta Group</span></h1>
          </div>

          <div className='row justify-content-center'>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={rohitgupta} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Rohit Gupta
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      10 Years with Siddhiananta Group
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={ashishharwani} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Ashish Harwani
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      10 Years with Siddhiananta Group
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={mukeshprajapat} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Mukesh Prajapat
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      9 Years with Siddhiananta Group
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={krishankumarsaini} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Krishan Kumar Saini
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      9 Years with Siddhiananta Group
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className='team-section'>
        <div className='container-fluid'>
          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Meet the Core Team of<br /><span>SiddhiAnanta Group</span></h1>
          </div>

          <div className='row justify-content-center'>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={vimalkumar} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Vimal Kumar
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      Business Development
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={manojdhawan} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Manoj Dhawan
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      Buying Head
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={anilsharma} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Anil Sharma
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      Business Development Manager
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={profile} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Devendra Chahra
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      Sales Manager
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={profile} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Rajesh Sen
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      Sales Manager
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={shivkumargurjar} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Shiv Kumar Gurjar
                    </h1>
                    <p class="text-sm sm:text-base lg:text-lg font-light">
                      Sales Executive
                    </p>
                  </div>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </section>

      <section className='team-section'>
        <div className='container-fluid'>
          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Meet the Management Team of<br /><span>SiddhiAnanta Group</span></h1>
          </div>

          <div className='row justify-content-center'>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={sunayanasingh} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Sunayana Singh
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={shwetasharma} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Shweta Sharma
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={sumitsaini} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Sumit Saini
                    </h1>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={girdharikoolwal} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Girdhari Koolwal
                    </h1>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={pankajmishra} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Pankaj Mishra
                    </h1>
                  </div>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </section>

      <section className='team-section'>
        <div className='container-fluid'>
          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Meet the Supporting Team of<br /><span>SiddhiAnanta Group</span></h1>
          </div>

          <div className='row justify-content-center'>

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={rahulsaini} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Rahul Saini
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={himanshubhardwaj} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Himanshu Bhardwaj
                    </h1>
                  </div>
                </div>
              </div>
            </div> */}

            <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={rajivkumarjonwal} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Rajiv Kumar Jonwal
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={komalsharma} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Komal Sharma
                    </h1>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className='col-md-3 col-12'>
              <div class="card-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <img src={rekhayadav} className='target-image' />
                <div class="inner-border-overlay" data-tilt-transform-element></div>
                <div class="content-area p-4 sm:p-5 lg:p-7" data-tilt-transform-element>
                  <div class="gradient-overlay"></div>
                  <div class="elevation-badge" data-tilt-transform-element>
                    <img src={starmark} />
                  </div>
                  <div class="text-block" data-tilt-transform-element>
                    <h1 class="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">
                      Rekha Yadav
                    </h1>
                  </div>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </section>

      <section className='team-section sectionbotgap vdosctn'>
        <div className='container'>
          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Our Team Spotlight</h1>
            <p>Watch our team in action as they share their expertise and passion.</p>
          </div>

          <div className='row justify-content-center'>

            <div className='col-md-6 col-12'>
              <div class="vdocard-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/BPyKIOD-RJs?si=3dSvGOfF92AKFLe1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="inner-border-overlay" data-tilt-transform-element></div>
              </div>
            </div>

            <div className='col-md-6 col-12'>
              <div class="vdocard-container" data-tilt data-tilt-max="10" data-tilt-speed="500" data-tilt-perspective="1800" data-tilt-glare data-tilt-max-glare="0.1" data-tilt-scale="1.03" data-tilt-reset="true">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/gIkdBN8DpFg?si=pvPdkvK30U9RJSi_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="inner-border-overlay" data-tilt-transform-element></div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className='teamgrp-section'>
        <h1 className='desk'>The Glorious Team of SiddhiAnanta Group</h1>
        <h1 className='mob'>The Glorious Team of<br/><span>SiddhiAnanta Group</span></h1>
        <h5 className='desk'>Our strength lies in our people</h5>
      </section>

    </>
  )
}

export default Blogs
